
function myToggleSiteMenu() {
    var element2 = document.getElementById("navOverlay");
    element2.classList.toggle("showMe");
}

function closeSiteNav() {
    myToggleSiteMenu();
}

function myToggleMenu() {
    var element = document.getElementById("toggleMenu");
    element.classList.toggle("showToggleMenu");
}
var topSlider = new Swiper('.staticTicker', {
    spaceBetween: 0,
    speed:1000,
    loop: true,
    autoplay: {
      delay: 2000,
    
    }, 
    breakpoints: {
        990: {
            slidesPerView: 1,
            slidesPerGroup: 1
        }
    },
});

$(document).ready(function() {  
	if ($(window).width() <= 980) {   
        $('.navication').click(function(event){
            event.stopPropagation();
        }); 


        $('nav .navication .mainTitle ').click(function(){
            $('.subMenu').removeClass('showDropDown')            

        })


        $(' .mainNavList > li > a').click(function() { 
            var $this = $(this); 
            if ($this.next().hasClass('showdrop')) {
                $this.next().removeClass('showdrop');
                $this.next().slideUp(350); 
            } else {
                $this.parent().parent().find('.megamenuWapper').removeClass('showdrop');
                $this.parent().parent().find('.megamenuWapper').slideUp(350);
                $this.next().toggleClass('showdrop');
                $this.next().slideToggle(350);
            }

        });   
        $('.navCatList li a') .click(function(){
            $ (this).next('.navCatChildList').toggleClass('showSubcategery')
        })
        $('.closeDropdown, .btnNavToggle') .click(function(){
            $('.navCatChildList').removeClass('showSubcategery')
        })
        
        

    }
});

var swiper = new Swiper('.homeWatchSlider', {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 8,
    loopFillGroupWithBlank: false,
    pagination: {
        el: '.swiper-pagination-home',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    loop: false,
    breakpoints: {
        990: {
            spaceBetween: 6,
            slidesPerView: 4,
            slidesPerGroup: 4
        },
        766: {
            spaceBetween: 6,
            slidesPerView: 2,
            slidesPerGroup: 2
        }
    },
});



// Keep exploring JS start
var swiper = new Swiper('.swiper-container', {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 8,
    loopFillGroupWithBlank: false,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    loop: false,
    breakpoints: {
        990: {
            spaceBetween: 6,
            slidesPerView: 4,
            slidesPerGroup: 4
        },
        766: {
            spaceBetween: 6,
            slidesPerView: 2,
            slidesPerGroup: 2
        }
    },
});

 
$(window).scroll(function () {
	if ($(this).scrollTop() > 340) {
		$('.rolexHeader ').addClass('fixed');
	} else {
		$('.rolexHeader').removeClass('fixed');
	}
});
    

if (document.documentElement.clientWidth <= 990) {
	$('.rolexNavList > li.dropDownclick > a').click(function(){
		$('.dropdown-menu').toggleClass('showNav')
	})
}
            
            
$('.crossicon').click(function(){
	$('.headerCovid').slideUp('');
});
          
if ($(window).width() <= 990) {
    $('.navCatList > li > a') .click(function(){
        $(this).next('.navCatChildList').addClass('showDrop');
    });
    $('.mainNavHeader .closeMe, .closeDropdown') .click(function(){
        $('.navCatChildList').removeClass('showDrop');
    });
    $(".mainNavList > li.ddYes > a").removeAttr("href"); 
}

 
$('.toggleMenu, .navFavicon  .closeMe, .mobileClose').on('click', function(){
	$('body').toggleClass('showMainNav');


});     
		
			
function subscribeIt() {
    $('#msg_div_success').hide();
    $('#loding').hide();

    if ($('#sub_email').val() == '') {
        $('#msg_div_success').show();
        setData('msg_div_success', '<div class="text-danger">Enter Email Address.</div>');
        $('#sub_email').focus();
        return false;
    } else if (IsEmail($('#sub_email').val()) == false) {
        $('#msg_div_success').show();
        setData('msg_div_success', '<div class="text-danger">Invalid Email Address.</div>');
        $('#sub_email').focus();
        return false;
    }
    $('#loding').show();
    var dataString = 'email=' + $('#sub_email').val();
    requestObj = jQuery.ajax({
        type: "GET",
        url: '/subscribe-it-ajax.php',
        data: dataString,
        cache: false,
        success: function (responseStr) {
            if(responseStr == 1){
                $('#loding').hide();
                $('#sub_email').val('');
                $('#msg_div_success').show();
                setData('msg_div_success', '<div class="text-success">Thanks for subscribing!</div>');
            } else if(responseStr == 9){
                $('#sub_email').val('');
                $('#loding').hide();
                $('#msg_div_success').show();
                setData('msg_div_success', '<div class="text-danger">Invalid Email Address.</div>');
            } else if(responseStr == 10){
                $('#sub_email').val('');
                $('#loding').hide();
                $('#msg_div_success').show();
                setData('msg_div_success', '<div class="text-danger">Please try after some time.</div>');
            } else if(responseStr == 11){
                $('#sub_email').val('');
                $('#loding').hide();
                $('#msg_div_success').show();
                setData('msg_div_success', '<div class="text-danger">Email ID already exists.</div>');
            }
        }
    });
}		

function setData(divId, innerHTML) {
    $('#' + divId).html(innerHTML);
}	

function IsEmail(email) {
    var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (regex.test(email)) {
        return true;
    } else {
        return false;
    }
}

    $('.closeInfoBar').click(function(){
    $('.stickyMasterTopBar').slideUp();

    });
    
    if ($(window).width() <= 766) {
 
  $(".mobAcc").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".ftpNav")
        .slideUp(200);
      
    } else {
      
      $(this)
        
      $(".mobAcc").removeClass("active");
      $(this).addClass("active");
      $(".ftpNav").slideUp(200);
      $(this)
        .siblings(".ftpNav")
        .slideDown(200);
    }
  });
   };   
   
   
$('.open360View').click(function(){ 

    $('#rolexPreowned360Container, #rolexPreowned360Background').addClass('showRolex');
    $('body').addClass('scrollNone');
    $('.rolexPreowned360-backdrop').addClass('hideScrolls'); 

    if($(this).data('init') != true){
        $(this).data('init', true);

        const new360View = document.getElementById('rolex-pre-owned-360');
        new360View.classList.add("cloudimage-360");
        window.CI360.add('rolex-pre-owned-360');
    }

});

$('.close360, #rolexPreowned360Background').click(function(){
    $('#rolexPreowned360Container, #rolexPreowned360Background').removeClass('showRolex');
    $('body').removeClass('scrollNone');
    $('.rolexPreowned360-backdrop').removeClass('hideScrolls');

});
     
$(".section-watchSpections ul li a").removeAttr("href"); 

     var btn = $('#gotoTop');
btn.on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({
        scrollTop: 0
    }, '500');
});

if ($(window).width() >= 992) {
$('#play-video').on('click', function(ev) {
    $("#video")[0].src += "&autoplay=1";
        ev.preventDefault();
});



}

var player; 
function onYouTubeIframeAPIReady() {
    player = new YT.Player('video', {
        events: {
            'onReady': onPlayerReady
        }
    });
}

function onPlayerReady(event) {
    var playButton = document.getElementById('play-video');
    playButton.addEventListener('click', function() {
        event.target.playVideo();
    });
}

// Load the IFrame Player API code asynchronously.
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);



$('#play-video1').on('click', function(ev) {
     $("#video1")[0].src += "&autoplay=1";
        ev.preventDefault();
});
$('.coverNew').on('click', function(ev) {
    $(this).addClass('hidevideo');
});
$('.tabbtn').click(function(){
    $(this).removeClass('active show')
})

// Bottom to top scroll
$(".bottomTop").click(function() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
});
$('#bookAnappointment .homeContactBlock label').click(function() {
    $('#bookAnappointment.tab-pane').removeClass('active');
    $('#please-note').addClass('active show');
});




